import { BuildingContext } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import { Fragment, useContext, useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { useStyles } from "Theme/styles";
import {
  Box,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { getPrettyDateString } from "helpers/FormatHelper";
import { GetRolesQueryResult } from "generated/graphql";
import { useQuery } from "@apollo/client";
import { GET_ROLES } from "lib/roles";

interface UserTableRow {
  taskName: string;
  userName: string;
  timeString: string;
  priority: number;
}
interface UserTasksTableState {
  loading: boolean;
  userTableRows: UserTableRow[];
}

const DEFAULT_STATE: UserTasksTableState = {
  loading: true,
  userTableRows: [],
};

export default function UserTasksTable() {
  const [state, setState] = useState<UserTasksTableState>(DEFAULT_STATE);
  const { getDatabase } = useContext(AuthContext);
  const { currentBuilding } = useContext(BuildingContext);

  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    initFirebase();
  }, []);

  const initFirebase = () => {
    if (!!getDatabase) {
      const database = getDatabase();

      let userTasksListener = database.ref(
        "buildings/" + currentBuilding?.Id + "/userTasks"
      );
      const userTableRows: UserTableRow[] = [];
      userTasksListener.on("value", (snapshot: any) => {
        const userTasks = snapshot.val();

        for (const key in userTasks) {
          if (userTasks.hasOwnProperty(key)) {
            const userTask = userTasks[key];
            const tableRow = {
              taskName: userTask.taskName,
              userName: userTask.userName,
              timeString: userTask.timeString,
              priority: userTask.priority,
            };
            userTableRows.push(tableRow);
          }
        }
        setState({ ...state, userTableRows, loading: false });
      });
      //this.firebaseLocationListeners.push(onlineBuildingGuardListener);
    }
  };

  const loading = state.loading;
  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Typography color="textPrimary" variant="h4">
                Pending User Tasks
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Task Name</TableCell>
                    <TableCell>User Name</TableCell>
                    <TableCell>Since</TableCell>
                    <TableCell>Priority</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {state.userTableRows.map((tableRow: UserTableRow) => (
                    <TableRow hover key={tableRow.timeString}>
                      <TableCell component="th" scope="row">
                        {tableRow.taskName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.userName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.timeString}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.priority}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
        </Paper>
      </Fragment>
    );
  }
}
